module.exports = __webpack_public_path__ + "img/elf.6432c4bd.jpg";